import ServicesHairAndMakeup from '@/components/Pages/Home Page/Services/ServicesHairAndMakeup.vue';
import ServicesMakeup from '@/components/Pages/Home Page/Services/ServicesMakeup.vue';
import ServicesPersonal from '@/components/Pages/Home Page/Services/ServicesPersonal.vue';
import SpecialEvents from '@/components/Pages/Home Page/SpecialEvents.vue';
import ServicesDirectory from '@/components/Pages/Home Page/Services/ServicesDirectory.vue';
import ServicesHair from '@/components/Pages/Home Page/Services/ServicesHair.vue';
import Weddings from '@/components/Pages/Home Page/Weddings.vue';

export default [
    {
        path: '',
        name: 'servicesDirectory',
        component: ServicesDirectory,
        meta: {
            preRender: true,
        },
    },
    {
        path: 'hair-and-makeup-services',
        name: 'servicesHairAndMakeup',
        meta: {
            displayName: 'Hair & Makeup',
            preRender: true,
        },
        component: ServicesHairAndMakeup,
    },
    {
        path: 'hair-services',
        name: 'servicesHair',
        meta: {
            displayName: 'Hair',
            preRender: true,
        },
        component: ServicesHair,
    },
    {
        path: 'makeup-services',
        name: 'servicesMakeup',
        meta: {
            displayName: 'Makeup',
            preRender: true,
        },
        component: ServicesMakeup,
    },
    {
        path: 'personal',
        name: 'personal',
        meta: {
            displayName: 'Personal',
            preRender: true,
        },
        component: ServicesPersonal,
    },
    {
        path: 'weddings',
        name: 'weddings',
        meta: {
            displayName: 'Weddings',
            preRender: true,
        },
        component: Weddings,
    },
    {
        path: 'events',
        name: 'events',
        meta: {
            displayName: 'Galas & Award Shows',
            preRender: true,
        },
        component: SpecialEvents,
    },
    {
        path: 'tv-and-film',
        name: 'tv-and-film',
        meta: {
            displayName: 'TV & Film',
            preRender: true,
        },
        component: SpecialEvents,
    },
];
